import {ProtocolCommand} from '../../../service-model/protocol-command.interface';
import {SHELL_PROTOCOL_OPERATIONS_NS} from '../shell-protocol-namespace.const';

export class ForceConnectGateway implements ProtocolCommand {
  constructor(public readonly gatewayId: string) {}

  getOperationName(): string {
    return `${SHELL_PROTOCOL_OPERATIONS_NS}.ForceConnectGateway`;
  }
}
